import React, { useState, Fragment } from 'react';
import { Progress } from 'antd';
import ProgressPage from '../common/progress';
import userImg from "../../../images/aiReport/user.png";
import userNumBg from "../../../images/aiReport/userNumBg.png";
import LineTootip from "../common/lineTooltip";


const UserInfo = (props) => {
    const {data = {}, totalDetail = {}, isLoad = false, hasAiAbility = false } = props;
    // 目前匹配度不需要显示
    const isJobMatch = false;
    return (
        <div className="userInfo">
            <div className="userInfoLeft">
                <div className="userInfoLeftImg">
                    <img src={data.avatar || userImg} onError={(e) => {
                        e.target.src = userImg;
                    }}/>
                </div>
                <div className="userWrap">
                    <h2>{data.userName || ''}</h2>
                    <div className={`userWrapPost ${hasAiAbility ? '' : 'userWrapPost1'}`}>
                        <span>应聘职位：</span>
                        <LineTootip blankText={data.postName || ''}/>
                    </div>
                </div>
            </div>
            {isLoad && hasAiAbility && <div className="userInfoRight">
                {!isJobMatch ? (
                    <Fragment>
                        <div className="userResultNew">
                            {totalDetail.totalScore >= 0 ? <div className="userResultNumWrap">
                                <div className="userResultNum">
                                    <img src={userNumBg}/>
                                    <p>{totalDetail.totalScoreStr || totalDetail.totalScore}</p>
                                </div>
                                <p className="userResultNumTotal">分/10分</p>
                            </div> : null}
                            <div className="userResultSuggest">
                                {totalDetail.sortNum >= 0 ? <p>当前排名：<span>{totalDetail.sortNum || 0}</span>/{totalDetail.sortCount || 0}</p> : null}
                                {totalDetail.totalScoreSuggest && <p>结果建议：<span className={`userResultSuggestName${totalDetail.resultStatus || 1}`}>{totalDetail.totalScoreSuggest}</span></p>}
                            </div>
                        </div>
                    </Fragment>
                ) : (
                    <Fragment>
                        <div className="userEchart">
                            <ProgressPage
                                percent={totalDetail.jobMatch || 0}
                                percentText={'职位匹配度'}
                            />
                        </div>
                        <div className="userResult">
                            <p>
                                <span>当前排名：</span>
                                <span>{totalDetail.sortNum || 0}/{totalDetail.sortCount || 0}</span>
                            </p>
                            <p>
                                <span>结果建议：</span>
                                <span className="userStatus">{totalDetail.resultSuggest || ''}</span>
                            </p>
                        </div>
                    </Fragment>
                )}
            </div>}
        </div>
    );
}

export default UserInfo;
